<template>
  <b-modal
    id="export-xero-timesheets"
    ref="export-xero-timesheets"
    size="lg-size"
    modal-class="modal-xero"
    no-close-on-esc
    no-close-on-backdrop
    centered
    hide-footer
    hide-header
    @hide="close"
  >
    <div class="modal-head">
      <div class="title-wrap">
        <h2 class="modal-title">
          {{ "Export Timesheets" }}
        </h2>
      </div>
      <div class="quickbooks-logo">
        <img
          src="/assets/images/xero-logo-blue.svg"
          alt="Atto"
          class="black-logo"
          width="50"
          height="50"
        />
      </div>
    </div>
    <div class="content-wrapper quickbooks-container">
      <div class="login-container signup-quickbooks synchronize-container">
        <h4>
          {{ "Select the pay period you want to export the timesheets for." }}
        </h4>
        <div class="s-team-wrapper body-container">
          <div class="head-labels">
            <div class="label email">
              <p>
                {{ "Pay Period" }}
              </p>
            </div>
            <div class="label">
              <p>
                {{ "Export Dates" }}
              </p>
            </div>
          </div>
          <ul class="quickbooks-member-list">
            <li>
              <div class="field-row">
                <div class="member-name">
                  <p class="member-name">
                    <select-dropdown-component
                      placeholder="Select Periods:"
                      :options="periods"
                      @onOptionSelected="onPeriodSelected"
                    />
                  </p>
                </div>
                <div class="member-name">
                  <select-dropdown-component
                    :value="startDay"
                    placeholder="Select days:"
                    :options="days"
                    @onOptionSelected="onDaySelected"
                  />
                </div>
              </div>
            </li>
          </ul>
        </div>
        <p class="disclaimer">
          {{
            "This will update your entire team’s timesheets. To export timesheets for a single member, select that member from the Timesheets page in Atto."
          }}
        </p>
        <p class="disclaimer">
          <span v-if="errorMessage" class="error-message">
            {{ errorMessage }}
          </span>
        </p>
      </div>
    </div>
    <div class="modal-footer">
      <button
        type="reset"
        class="atto-btn cancel"
        data-dismiss="modal"
        @click="close"
      >
        {{ label.get("cancel") }}
      </button>
      <button
        :disabled="isDisabled"
        class="atto-btn submit save-changes"
        type="submit"
        @click="submit"
      >
        {{ "Export" }}
      </button>
    </div>
  </b-modal>
</template>

<script>
import CompanyService from "../services/CompanyService";
import SelectDropdownComponent from "../../../../shared/components/SelectDropdownComponent";

export default {
  name: "ExportXeroTimesheetsComponent",
  components: {
    SelectDropdownComponent,
  },
  data() {
    return {
      periods: [],
      days: [],
      startDay: null,
      payroll_calendar_id: null,
      response: [],
      isDisabled: true,
      errorMessage: "",
    };
  },

  mounted() {
    document.body.appendChild(this.$el);
    this.$store.commit("showLoading");
    CompanyService.getXeroTimesheetsPeriod()
      .then((result) => {
        let periods = [];
        $.each(result, function (key, value) {
          periods.push({
            value: value.calendar_type,
            label: value.name,
            index: key,
          });
        });

        this.periods = periods;
        this.response = result;

        this.$refs["export-xero-timesheets"].show();
        this.$store.commit("hideLoading");
      })
      .catch((error) => {
        this.$store.commit("hideLoading");
        if (error.response.status === 403) {
          this.$store.commit("xeroHasError403", true);
          this.$root.$emit("showXeroErrors");
        }
      });
  },
  methods: {
    submit() {
      var data = {
        date: this.startDay,
        payroll_calendar_id: this.payroll_calendar_id,
        overwrite_data: false,
      };
      this.$store.commit("showLoading");
      CompanyService.postTimeseetsToXero(data)
        .then((result) => {
          this.$store.commit("hideLoading");
          if (result.data.show_overwrite_data_modal) {
            this.$root.$emit("hideXeroTimesheetsExport", {
              showOverwriteDataModal: true,
              xeroStartDay: this.startDay,
              payroll_calendar_id: this.payroll_calendar_id,
            });
          }

          if (result.data.queue_is_active) {
            //ToDo need to fix this
            this.$root.$emit("hideXeroTimesheetsExport", {
              queueIsActive: true,
            });
          } else {
            this.$awn.success(result.data.message);
            this.$root.$emit("hideXeroTimesheetsExport");
          }
        })
        .catch((error) => {
          this.$store.commit("hideLoading");
          if (error.response.status === 403) {
            this.$store.commit("xeroHasError403", true);
            this.$root.$emit("showXeroErrors");
          }

          if (
            error.response.status === 400 &&
            error.response.data.error.country_code === "GB"
          ) {
            this.$root.$emit("showXeroUk400ErrorModal");
          }
          this.errorMessage = error.response.data.error.message;
        });
    },
    close() {
      this.$root.$emit("hideXeroTimesheetsExport");
    },
    onDaySelected(item) {
      this.startDay = item.value;
      this.payroll_calendar_id = item.payroll_calendar_id;
      this.isDisabled = false;
    },
    onPeriodSelected(item) {
      var period = this.response[item.index];
      var days = [];
      this.startDay = null;
      this.isDisabled = true;
      $.each(period.days, function (index, day) {
        days.push({
          value: day.from + "," + day.to,
          label: day.from + " - " + day.to,
          payroll_calendar_id: period.payroll_calendar_id,
        });
      });
      this.days = days.sort(function (a, b) {
        return a.value - b.value;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.modal-entry-delete {
  .modal-content {
    .modal-body {
      .content-wrapper {
        &.password-confirm.has-error {
          padding-bottom: 16px;
        }
      }
    }
  }
}

.modal-lg-size {
  .modal-content {
    .modal-body {
      .content-wrapper {
        display: flex;

        &.quickbooks-container {
          padding: 0 0 24px 0 !important;
          flex-direction: column;
        }

        h4 {
          font-weight: 400;
          font-size: 0.875rem;
          line-height: 1.25rem;
          margin-bottom: 24px;
          padding-left: 48px;
          color: #666666;
        }

        p.seats-desc {
          font-size: 0.75rem;
          line-height: 1rem;
          color: $atto-font-color;
          font-family: $roboto-font;
          font-weight: 400;
          margin-bottom: 16px !important;
        }

        .head-labels {
          display: flex;
          flex-direction: row;
          padding: 5px 12px 6px;
          margin: 0 48px;
          background: #fafafa;
          border: 1px solid #efefef;

          .label {
            display: inline-flex;
            width: 50%;
          }
        }

        .field-row {
          display: flex;
          flex-direction: row;
          margin-bottom: 0px !important;
          align-items: center;
          position: relative;
          width: 100%;

          p.member-name {
            font-size: 0.875rem;
            line-height: 1.25rem;
            color: $atto-font-color;
            font-family: $roboto-font;
            font-weight: 400;
            margin-bottom: 0px;
          }

          input {
            border: 2px solid $atto-light-grey;
            padding: 8px 12px;
            font-size: 0.875rem;
            line-height: 1.25rem;
            font-family: $roboto-font;
            font-weight: $roboto-regular;
            color: $atto-font-color;
            width: 100%;
            max-width: 360px;
            -webkit-appearance: none;
            border-radius: 0;
            @include base-transition(ease all 0.1s);

            &:focus {
              border-color: $atto-dark-grey;
            }
          }

          input.error {
            border: 2px solid $atto-red;
          }

          .checkbox-wrapper {
            margin-right: 16px;
            width: 24px;
          }

          .check-wrapper {
            .custom-checkbox {
              margin-left: 14px;
            }
          }

          .member-name {
            flex-grow: 1;
          }

          .member-dropdown {
            width: calc(50% - 16px);
          }

          .atto-select {
            margin-right: 0;

            .select-heading {
              width: 100%;
              max-width: 360px;
              flex-direction: row;
              @include base-transition(ease all 0.1s);

              span {
                flex-grow: 1;
                display: inline-flex;
              }

              i {
                @include base-transition(ease all 0.1s);
              }

              &:hover {
                border-color: #c7c7c7;

                i {
                  color: #c7c7c7;
                }
              }
            }

            .select-options {
              .heading {
                i {
                  margin-right: 0;
                  color: #c7c7c7;
                }
              }
            }
          }
        }

        ul.quickbooks-member-list {
          > li {
            display: flex;
            flex-direction: row;
            align-items: center;
            padding: 12px 48px 0 48px;
            flex-wrap: wrap;

            > *:not(&::after) {
              flex: 1;
            }

            /*border-bottom: 1px solid #efefef;*/

            &::after {
              content: "";
              display: inline-flex;
              width: 100%;
              height: 1px;
              background-color: #efefef;
              margin-top: 16px;
              margin-left: auto;
            }

            .check-wrapper {
              width: 40px;
            }

            .member-name {
              width: calc(50% - 32px);
              p {
                width: calc(100% - 32px);
              }
            }
          }
        }
      }
    }
  }
}

.password-confirm {
  p {
    margin-bottom: 12px !important;
    text-align: left !important;
  }

  input {
    width: 100%;
    border: 2px solid #efefef;
    padding: 5px 10px;
    font-family: "Roboto", sans-serif;
    line-height: 36px;
    color: #262626;

    &:focus {
      border-color: #00b9cb;
    }
  }
}
</style>
